// @flow

import React from 'react'
import Container from './Container'
import Appear from './Appear'

type Props = {
  white?: boolean,
  title: string,
}

const SectionTitle = ({ white, title }: Props) => {
  return (
    <Appear>
      <Container className="py-8 text-xl font-black text-black">
        <h2><span aria-hidden="true" className={`${white ? "text-white" : "text-dark-gray"}`}>]</span> {title}</h2>
      </Container>
    </Appear>
  )
}

export default SectionTitle
